import React from "react";
import { Text } from "react-native-paper";
import { View } from "react-native";
import AccordionItem from "../AccordionItem";

const AccordionItemDescription = ({styles, j, subSection}) => (
    <View style={{paddingBottom: 10, paddingTop: 10}}>
        <View style={styles.subSection} key={j}>
            <View style={styles.textdescriptionDesignOne}>
                <Text style={{ color: "#666"}}>{subSection.description}</Text>
                {/* <AccordionItem subSection={subSection} /> */}
            </View>
        </View>
    </View>
);

export default AccordionItemDescription;